import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';


import { AuthService } from '../../_services/auth.service';
import { LoadingSpinnerService } from '../../_services/loading-spinner.service';
import { NotificationService, NotificationType } from '../../_services/notification.service'

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit {


  @ViewChild('passwordInfo', { static: false }) public tooltip: NgbTooltip;

  public firstNameValid: boolean = true;
  public lastNameValid: boolean = true;
  public passwordValidationStatus: boolean = true;
  public validPasswordmessage;
  public firstNameErrorMsg;
  public lastNameErrorMsg;
  public firstName;
  public lastName;

  isSignupFormSubmitted = false
  signUpForm = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    username: new FormControl('', [Validators.required, Validators.pattern(/^[a-zA-Z0-9]+$/), Validators.minLength(4)]),
    password: new FormControl('', [Validators.required, Validators.minLength(8), Validators.maxLength(50)]),
    confirmPassword: new FormControl('', [Validators.required, Validators.minLength(8), Validators.maxLength(50)]),
    first_name: new FormControl('', [Validators.required, Validators.maxLength(40), Validators.pattern("[a-zA-Z][a-zA-Z ]+")]),
    last_name: new FormControl('', [Validators.pattern("[a-zA-Z]+")]),

  });

  constructor(private _authService: AuthService,
    private _router: Router,
    private loadingSpinnerService: LoadingSpinnerService,
    private _notificationService: NotificationService, ) { }


  ngOnInit() { }

  signup() {
    // this.loadingSpinnerService.showLoader(true);
    let notificationID = this._notificationService.showNotification({
      message: "Checking..",
      type: NotificationType.info,
      isLoading: true
    })
    this._notificationService.notificationID.push(notificationID);
    if (this.signUpForm.controls.confirmPassword.value == this.signUpForm.controls.password.value) {


      this._authService.signup(this.signUpForm.value).subscribe((result) => {
        this.isSignupFormSubmitted = true;
        // this.loadingSpinnerService.showLoader(false);
        let notifyID = this._notificationService.notificationID.shift();
        this._notificationService.changeStatus(notifyID, NotificationType.success, result['message']);
      },
        (error) => {
          if (error.status !== 403 && error.status !== 415 && error.status !== 500) {
            let notifyID = this._notificationService.notificationID.shift();
            this._notificationService.changeStatus(notifyID, NotificationType.error, error.error.message);
          }
          // this.loadingSpinnerService.showLoader(false);
        })
    }
  }

  resend() {
    let notificationID = this._notificationService.showNotification({
      message: "Checking..",
      type: NotificationType.info,
      isLoading: true
    })
    this._notificationService.notificationID.push(notificationID);

    // this.loadingSpinnerService.showLoader(true);
    this._authService.resendConfrimationEmail({ email: this.signUpForm.get('email').value }).subscribe((result) => {
      let notifyID = this._notificationService.notificationID.shift();
      this._notificationService.changeStatus(notifyID, NotificationType.success, result['message']);
    },
      (error) => {
        if (error.status !== 403 && error.status !== 415 && error.status !== 500) {
          let notifyID = this._notificationService.notificationID.shift();
          this._notificationService.changeStatus(notifyID, NotificationType.error, error.error.message);
        }
        // this.loadingSpinnerService.showLoader(false);
      })
  }

  firstNameCheck(element) {

    if (element.nativeElement.classList.contains('ng-invalid')) {
      this.firstNameValid = false;
      this.firstNameErrorMsg = "Please enter a valid  first name without numerics and special character(space excluded)";

    }
    else {
      this.firstNameValid = true;
      this.firstNameErrorMsg = " ";
    }
  }
  lastNameCheck(element) {
    if (element.nativeElement.classList.contains('ng-invalid')) {
      this.lastNameValid = false;
      this.lastNameErrorMsg = "Please enter a valid  last name without numerics and special character (space excluded) ";

    }
    else {
      this.lastNameValid = true;
      this.lastNameErrorMsg = " ";
    }
  }



  validatePassword(value) {


    let weakPasswords = ["1234", "12345", "123456", "1234567", "12345678", "123456789", "qwerty", "qwer", "qwert", "qwe123", "123qwe", "asd123", "123asd", "asdf", "password", "pass"];

    for (var i = 0, len = weakPasswords.length; i < len; i++) {

      if (weakPasswords[i] == value) {
        this.passwordValidationStatus = false;

        this.validPasswordmessage = "Enter a strong password.";
        break;
      }
      else {
        if ((value.length < 4) || (value.length > 50) || (value.replace(/ +/g, "").length != value.length)) {
          this.tooltip.open();
          this.passwordValidationStatus = false;
          this.validPasswordmessage = "Enter a valid password (Minimum 4 letters).";

        }
        else {
          this.tooltip.close();
          this.passwordValidationStatus = true;
        }
      }

    }





    // Object.keys(weakPasswords).forEach(key => {
    //    if(value["password"] == weakPasswords[key]){

    //     console.log(`key is ${key} and value is ${value}`);
    //     this.passwordValidationStatus = false;

    //    }
    //    else{
    //     if(this.passwordValidationStatus){
    //      this.passwordValidationStatus = true;
    //     }
    //     console.log(this.passwordValidationStatus);
    //    }


    // });


  }

}

